import { SwipeHandler } from './handler/SwipeHandler';
Oskari.clazz.define('Oskari.mapframework.bundle.layerswipe.LayerSwipeBundleInstance', function () {
  this.mapModule = null;
  this.sandbox = null;
  this.plugin = null;
  this.loc = Oskari.getMsg.bind(null, this.getName());
}, {
  __name: 'LayerSwipe',
  _startImpl: function _startImpl(sandbox) {
    var _this = this,
      _this$state;
    this.sandbox = sandbox;
    this.mapModule = sandbox.findRegisteredModuleInstance('MainMapModule');
    this.handler = new SwipeHandler(this);
    sandbox.registerAsStateful(this.mediator.bundleId, this);
    if (Oskari.dom.isEmbedded()) {
      this.plugin = Oskari.clazz.create('Oskari.mapframework.bundle.layerswipe.plugin.LayerSwipePlugin', this.conf);
      this.plugin.setHandler(this.handler);
      this.mapModule.registerPlugin(this.plugin);
      this.mapModule.startPlugin(this.plugin);
    } else {
      var addToolButtonBuilder = Oskari.requestBuilder('Toolbar.AddToolButtonRequest');
      var buttonConf = {
        iconCls: 'tool-layer-swipe',
        tooltip: this.loc('toolLayerSwipe'),
        sticky: true,
        callback: function callback() {
          return _this.setToolActive(!_this.getState().active);
        }
      };
      sandbox.request(this, addToolButtonBuilder('LayerSwipe', 'basictools', buttonConf));
    }
    if ((_this$state = this.state) !== null && _this$state !== void 0 && _this$state.active) {
      if (!this.plugin) {
        // AddToolButtonRequest prefixes group and have to use prefixed group on select tool
        // It's little confusing that tool can't be selected using group which was used on add
        this.getSandbox().postRequestByName('Toolbar.SelectToolButtonRequest', ['LayerSwipe', 'default-basictools']);
      }
      Oskari.on('app.start', function () {
        return _this.handler.setActive(true);
      });
    }
  },
  setToolActive: function setToolActive(active) {
    var _this$handler;
    if (!this.plugin) {
      if (!active) {
        this.getSandbox().postRequestByName('Toolbar.SelectToolButtonRequest', []);
        return;
      } else if (Oskari.util.isMobile()) {
        Oskari.dom.showNavigation(false);
      }
    }
    (_this$handler = this.handler) === null || _this$handler === void 0 || _this$handler.setActive(active);
  },
  getSandbox: function getSandbox() {
    return this.sandbox;
  },
  getMapModule: function getMapModule() {
    return this.mapModule;
  },
  getHandler: function getHandler() {
    return this.handler;
  },
  getState: function getState() {
    var _this$handler2;
    return ((_this$handler2 = this.handler) === null || _this$handler2 === void 0 ? void 0 : _this$handler2.getState()) || {};
  },
  getStateParameters: function getStateParameters() {
    var _this$getState = this.getState(),
      active = _this$getState.active;
    if (active) {
      return 'swipe=true';
    }
    return '';
  },
  eventHandlers: {
    'Toolbar.ToolSelectedEvent': function ToolbarToolSelectedEvent(event) {
      if (event.getToolId() !== 'LayerSwipe' && event.getToolId() !== 'link' && event.getToolId() !== 'save_view') {
        var _this$handler3;
        // This bundle generates state for both link and saving views, but only if it's active.
        // If we deactivate when link or save view tools are clicked the state is not stored as expected.
        // So we need to keep the swipe tool active when these tools are clicked.
        (_this$handler3 = this.handler) === null || _this$handler3 === void 0 || _this$handler3.setActive(false);
      }
    },
    'AfterMapLayerAddEvent': function AfterMapLayerAddEvent() {
      var _this$handler4;
      (_this$handler4 = this.handler) === null || _this$handler4 === void 0 || _this$handler4.onMapLayerEvent();
    },
    'AfterMapLayerRemoveEvent': function AfterMapLayerRemoveEvent() {
      var _this$handler5;
      (_this$handler5 = this.handler) === null || _this$handler5 === void 0 || _this$handler5.onMapLayerEvent();
    },
    'AfterRearrangeSelectedMapLayerEvent': function AfterRearrangeSelectedMapLayerEvent() {
      var _this$handler6;
      (_this$handler6 = this.handler) === null || _this$handler6 === void 0 || _this$handler6.onMapLayerEvent();
    },
    'MapLayerVisibilityChangedEvent': function MapLayerVisibilityChangedEvent(event) {
      var _this$handler7;
      (_this$handler7 = this.handler) === null || _this$handler7 === void 0 || _this$handler7.onMapLayerEvent();
    },
    'MapSizeChangedEvent': function MapSizeChangedEvent() {
      var _this$handler8;
      (_this$handler8 = this.handler) === null || _this$handler8 === void 0 || _this$handler8.onMapSizeChange();
    }
  }
}, {
  extend: ['Oskari.BasicBundle'],
  protocol: ['Oskari.bundle.BundleInstance', 'Oskari.mapframework.module.Module']
});